import * as React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import getClientEnvironment from '../../getClientEnvironment';
import './index.scss';

const config = getClientEnvironment();

export default () => (
  <Card className="info-card">
    <CardBody>
      <CardTitle>Technology</CardTitle>

      <p className="lead">Tools and frameworks used to build {config.TITLE}:</p>
      <ul>
        <li>
          <a href="https://www.heroku.com/">Heroku</a> hosting
        </li>
        <li>
          <a href="https://nodejs.org">Node.js</a> server
        </li>
        <li>
          <a href="https://mongodb.org">MongoDB</a> data store
        </li>
        <li>
          <a href="https://reactjs.org/">React</a> (UI framework)
        </li>
        <li>
          <a href="https://www.apollographql.com/">Apollo GraphQL</a> for
          fetching and caching data, and server-side rendering
        </li>
        <li>
          <a href="http://developers.strava.com/">Strava API</a>
        </li>
        <li>
          <a href="https://www.mapbox.com/developers/">Mapbox</a> for maps and
          map styling
        </li>
        <li>
          <a href="http://uber.github.io/deck.gl/">Deck.GL</a> for the 3D map
          overlays
        </li>
        <li>
          <a href="https://getbootstrap.com/">Bootstrap</a> styles
        </li>
      </ul>
    </CardBody>
  </Card>
);



// WEBPACK FOOTER //
// ./src/client/components/About/TechnologyInfo.tsx